import React, { useState, useEffect } from 'react';
import { translatedMessage } from '../../service/LanguageService';
import DOMPurify from 'dompurify';

const CompetitionJobDutyViewComponent = (props) => {
    const [competition, setCompetition] = useState(null);

    useEffect(() => {
        const getCompetition = async () => {
            // console.log(props?.competition);
            setCompetition(props?.competition);
        };

        getCompetition();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [props?.competition]);

    DOMPurify.addHook('afterSanitizeAttributes', function (node) {
        // set all elements owning target to target=_blank
        if ('target' in node) {
            node.setAttribute('target', '_blank');
            node.setAttribute('rel', 'noopener');
        }
    });

    return (
        <>
            <div className='col-12 mt-5'>
                <h5 className='mb-0'>{translatedMessage('job.jobDuty')}</h5>
            </div>
            <div className='col-12'>
                <div className='w-full p-2 pcn-panel-border'>
                    {competition?.jobDuty && <span dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(competition?.jobDuty) }} />}
                    {!competition?.jobDuty && "-"}
                </div>
            </div>
        </>
    );
};

export default CompetitionJobDutyViewComponent;
